import React from 'react';
import PropTypes from 'prop-types';

import { withGoogle } from 'bento-ordering/base/hoc/withGoogle';
import {
  GOOGLE_MAPS_STATIC_IMAGE_DESKTOP_WIDTH,
  GOOGLE_MAPS_STATIC_IMAGE_DESKTOP_HEIGHT,
  GOOGLE_MAPS_STATIC_IMAGE_MOBILE_AND_TABLET_WIDTH,
  GOOGLE_MAPS_STATIC_IMAGE_MOBILE_AND_TABLET_HEIGHT
} from 'bento-ordering/base/constants/defaultMapProps';

/*
  This component renders the Google maps static image thumbnail.
  It renders a different static url based on the size of the screen to ensure
  that both the resolution and aspect ratio is preserved.

  The three breakpoints are:
    Mobile - < 600px
    Tablet - > 600px and < 960px
    Desktop - > 960px
*/

const StaticMapComponent = props => {
  const {
    center,
    staticUrls,
    loadingElement,
    isMediumAndUp,
    isSmallAndUp,
    name,
    isFetching
  } = props;

  // find the static url associated with the latitude and longitude
  const mapData = staticUrls.find(
    ({ lat, lng }) => lat === center.lat && lng === center.lng
  );

  const responsiveWidth = isMediumAndUp
    ? GOOGLE_MAPS_STATIC_IMAGE_DESKTOP_WIDTH
    : GOOGLE_MAPS_STATIC_IMAGE_MOBILE_AND_TABLET_WIDTH;

  const responsiveHeight = isMediumAndUp
    ? GOOGLE_MAPS_STATIC_IMAGE_DESKTOP_HEIGHT
    : GOOGLE_MAPS_STATIC_IMAGE_MOBILE_AND_TABLET_HEIGHT;

  const isLoaded = mapData && !isFetching;

  if (isLoaded) {
    let url;

    if (isMediumAndUp) {
      url = mapData.static_url_desktop;
    } else if (isSmallAndUp) {
      url = mapData.static_url_tablet;
    } else {
      url = mapData.static_url_mobile;
    }

    return (
      <img
        src={url}
        width={responsiveWidth}
        height={responsiveHeight}
        alt={name}
      />
    );
  } else {
    return (
      <div data-testid="google-maps-static-thumbnail-loading">
        {loadingElement}
      </div>
    );
  }
};

StaticMapComponent.propTypes = {
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      lat: PropTypes.string,
      lng: PropTypes.string
    })
  ).isRequired,
  staticUrls: PropTypes.array.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isMediumAndUp: PropTypes.bool.isRequired,
  isSmallAndUp: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  loadingElement: PropTypes.node
};

StaticMapComponent.defaultProps = {
  loadingElement: <div />
};

export default withGoogle(StaticMapComponent);
